// extracted by mini-css-extract-plugin
export default {"templateFilesContent":"TemplateFiles_templateFilesContent__lDibp","tabContainer":"TemplateFiles_tabContainer__wIuX7","tabContent":"TemplateFiles_tabContent__+rdBo"};